import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

import App from "./App";

// Cache-busting token for the runtime-loaded translation files. It is stamped
// with a fresh value on every production build (see the "build" script in
// package.json), so browsers re-fetch translations after each deploy instead
// of serving a stale, heuristically-cached copy.
const ASSET_VERSION = process.env.REACT_APP_ASSET_VERSION || "0";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ["en", "fr", "es", "dari", "ua", "ru"],
    fallbackLng: "en",
    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: `static/assets/locales/{{lng}}/translation.json?v=${ASSET_VERSION}`,
    },
    react: { useSuspense: false },
    debug: false,
  });

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root")
);
